var _path, _line, _path2, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5173 23.922C20.9465 23.6288 21.0567 23.0431 20.7634 22.6139C20.4701 22.1848 19.8845 22.0746 19.4553 22.3679L20.5173 23.922ZM14.8024 24.6121L14.8474 23.672L14.8474 23.672L14.8024 24.6121ZM9.78229 22.6565L9.1795 23.3793L9.17951 23.3793L9.78229 22.6565ZM6.95683 18.0693L6.0401 18.2824L6.0401 18.2824L6.95683 18.0693ZM11.1116 8.73665L10.6565 7.91281L10.6565 7.91281L11.1116 8.73665ZM16.411 7.76654L16.2773 8.69817L16.411 7.76654ZM21.2236 10.1883L21.8921 9.52575L21.8921 9.52575L21.2236 10.1883ZM22.6696 15.1477C22.7389 15.6628 23.2127 16.0243 23.7278 15.955C24.243 15.8857 24.6045 15.4119 24.5352 14.8968L22.6696 15.1477ZM19.4553 22.3679C18.1022 23.2925 16.4844 23.7503 14.8474 23.672L14.7574 25.5522C16.8036 25.6501 18.8259 25.0778 20.5173 23.922L19.4553 22.3679ZM14.8474 23.672C13.2104 23.5936 11.6437 22.9833 10.3851 21.9337L9.17951 23.3793C10.7528 24.6913 12.7112 25.4542 14.7574 25.5522L14.8474 23.672ZM10.3851 21.9337C9.12646 20.8841 8.24467 19.4525 7.87356 17.8562L6.0401 18.2824C6.50399 20.2778 7.60623 22.0673 9.1795 23.3793L10.3851 21.9337ZM7.87356 17.8562C7.50245 16.2599 7.66228 14.5861 8.32881 13.0889L6.60916 12.3234C5.77601 14.1949 5.57621 16.2871 6.0401 18.2824L7.87356 17.8562ZM8.32881 13.0889C8.99533 11.5918 10.1321 10.3529 11.5667 9.56048L10.6565 7.91281C8.86332 8.90336 7.44231 10.4519 6.60916 12.3234L8.32881 13.0889ZM11.5667 9.56048C13.0012 8.76805 14.6551 8.46529 16.2773 8.69817L16.5448 6.83492C14.517 6.54382 12.4496 6.92227 10.6565 7.91281L11.5667 9.56048ZM16.2773 8.69817C17.8995 8.93105 19.4015 9.68685 20.5551 10.8508L21.8921 9.52575C20.45 8.07077 18.5726 7.12602 16.5448 6.83492L16.2773 8.69817ZM20.5551 10.8508C21.7088 12.0148 22.4512 13.5234 22.6696 15.1477L24.5352 14.8968C24.2622 12.8665 23.3342 10.9807 21.8921 9.52575L20.5551 10.8508Z",
    fill: "#DF3030"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.4425,
    y1: 16.1526,
    x2: 18.9719,
    y2: 16.1526,
    stroke: "#F1A7A7",
    strokeWidth: 1.88235,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0781 21.8789L26.8577 20.4769C27.4796 19.987 27.4866 19.0468 26.8721 18.5477L25.0781 17.0906",
    stroke: "#E44E4E",
    strokeWidth: 1.88235,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.9,
    x1: 0.941176,
    y1: -0.941176,
    x2: 4.70588,
    y2: -0.941176,
    transform: "matrix(-1 4.37114e-08 4.37114e-08 1 24.6195 20.3516)",
    stroke: "#F1A7A7",
    strokeWidth: 1.88235,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/Withdraw.475c25e22483192ef980f74b36d8c119.svg";
export { ForwardRef as ReactComponent };